import {
  Stack,
  Typography,
} from '@mui/material';
import LocationFields from '../CreateOperationPage/components/LocationFields';
import { OperationLocation } from '@networkRequest/operationsService';

interface EditLocationProps {
  title: string;
  locationData: OperationLocation;
  onLocationDataChange: (field: string, value: string) => void;
  backgroundColor?: string;
}

export default function EditLocation({
  title,
  locationData,
  onLocationDataChange,
  backgroundColor
}: EditLocationProps) {

  if (!locationData) return null;

  return (
    <Stack spacing={4}>
      <Stack spacing={2}>
        <Typography variant="h5">
          {title}
        </Typography>
        <Typography variant="body1">
          Required fields are marked with an asterisk.
        </Typography>
      </Stack>

      <Stack
        sx={{
          p: backgroundColor === 'transparent' ? 0 : 2,
          backgroundColor: backgroundColor === 'transparent' ? 'transparent' : (backgroundColor || ((theme) => theme.palette.grey[50])),
          borderRadius: backgroundColor === 'transparent' ? 0 : '10px',
          width: '100%',
          maxWidth: 832
        }}
      >
        <LocationFields
          name={locationData.name || ''}
          street_address_1={locationData.street_address_1 || ''}
          street_address_2={locationData.street_address_2 || ''}
          city={locationData.city || ''}
          state={locationData.state || ''}
          zip={locationData.zip || ''}
          onChange={onLocationDataChange}
        />
      </Stack>
    </Stack>
  );
}